// @ts-nocheck
/* Port of ReleaseCard.js (183L). BYTE-IDENTICAL.
 * Collapsed by default (defaultExpanded=false); title toggles expand.
 * onShare commented-out in v1 — kept as comment.
 */
import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import VersionBadge from './VersionBadge';
import ReleaseTypeBadge from './ReleaseTypeBadge';
import TagChip from './TagChip';
import QuickSummaryChecklist from './QuickSummaryChecklist';
import { formatDateTime } from './releaseUtils';

const ReleaseCard = ({
  release,
  canManage,
  onOpen,
  onEdit,
  onTogglePublish,
  onTogglePin,
  onToggleDisable,
  onShare,
  busy,
  defaultExpanded = false,
}: any) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  if (!release) return null;
  const {
    quick_summary,
    title,
    summary,
    tags = [],
    highlights = [],
    is_pinned,
    is_published,
    is_disabled,
    release_type,
    version,
    edit_count,
    last_edited_at,
  } = release;

  return (
    <article
      className={`rc-card rc-fade-up ${
        expanded ? '' : 'rc-card--collapsed'
      }`}
    >
      <div className="rc-card__head">
        <div className="rc-card__meta">
          <VersionBadge version={version} />
          <ReleaseTypeBadge type={release_type} />
        </div>
        <div className="rc-card__meta">
          {is_pinned && (
            <span className="rc-pin-badge" aria-label="Pinned release">
              📌 Pinned
            </span>
          )}
          {!is_published && (
            <span
              className="rc-draft-badge"
              aria-label="Draft — not public"
            >
              ✎ Draft
            </span>
          )}
          {is_disabled && (
            <span className="rc-disabled-badge" aria-label="Disabled">
              ⊘ Disabled
            </span>
          )}
          <button
            type="button"
            className="rc-card__toggle"
            aria-expanded={expanded}
            aria-label={expanded ? 'Collapse release' : 'Expand release'}
            title={expanded ? 'Collapse' : 'Expand'}
            onClick={() => setExpanded((v: boolean) => !v)}
          >
            <span className="rc-card__chevron" aria-hidden="true">
              <FiChevronDown size={18} />
            </span>
          </button>
        </div>
      </div>

      <h3
        className="rc-card__title"
        style={{ cursor: 'pointer' }}
        onClick={() => setExpanded((v: boolean) => !v)}
      >
        {title}
      </h3>

      {!expanded && summary && (
        <p className="rc-card__summary rc-card__summary--clamp">{summary}</p>
      )}

      {expanded && (
        <>
          {summary && <p className="rc-card__summary">{summary}</p>}

          {quick_summary && (
            <p
              className="rc-card__summary"
              style={{ marginTop: 8, fontStyle: 'italic' }}
            >
              {quick_summary}
            </p>
          )}

          {highlights.length > 0 && (
            <QuickSummaryChecklist highlights={highlights.slice(0, 4)} />
          )}

          {tags.length > 0 && (
            <div className="rc-tags">
              {tags.map((t: any) => (
                <TagChip key={t.id} tag={t} />
              ))}
            </div>
          )}

          {edit_count > 0 && (
            <div
              className="rc-edit-meta"
              title={`Last edited ${formatDateTime(last_edited_at)}`}
            >
              ✎ Edited {edit_count} {edit_count === 1 ? 'time' : 'times'} ·
              last {formatDateTime(last_edited_at)}
            </div>
          )}

          <div className="rc-card__foot">
            <div className="rc-card__actions">
              <button
                type="button"
                className="rc-btn rc-btn--primary"
                onClick={() => onOpen(release)}
              >
                View details →
              </button>
              {/* {onShare && (
                <button
                  type="button"
                  className="rc-btn rc-btn--ghost"
                  onClick={() => onShare(release)}
                  title="Copy a shareable link to this release (Super Admins only)"
                >
                  🔗 Share
                </button>
              )} */}
            </div>

            {canManage && (
              <div className="rc-card__actions">
                <button
                  type="button"
                  className="rc-btn rc-btn--ghost"
                  onClick={() => onTogglePin(release)}
                  disabled={busy}
                >
                  {is_pinned ? 'Unpin' : 'Pin'}
                </button>
                <button
                  type="button"
                  className="rc-btn rc-btn--ghost"
                  onClick={() => onTogglePublish(release)}
                  disabled={busy}
                >
                  {is_published ? 'Move to draft' : 'Publish'}
                </button>
                {onToggleDisable && (
                  <button
                    type="button"
                    className="rc-btn rc-btn--ghost"
                    onClick={() => onToggleDisable(release)}
                    disabled={busy}
                  >
                    {is_disabled ? 'Enable' : 'Disable'}
                  </button>
                )}
                <button
                  type="button"
                  className="rc-btn"
                  onClick={() => onEdit(release)}
                  disabled={busy}
                >
                  Edit
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </article>
  );
};

export default ReleaseCard;
